var map = {
	"./arrow-right.png": "223a",
	"./baby-care.png": "d0b2",
	"./banner1.png": "5cfd",
	"./bg.png": "6b36",
	"./bg2.png": "8ed1",
	"./copy.png": "8a3b",
	"./family-care.png": "25bf",
	"./feature-baby.png": "cda5",
	"./feature-mom.jpeg": "f296",
	"./icon-1.png": "e076",
	"./icon-2.png": "d347",
	"./icon-3.png": "7cbc",
	"./icon-4.png": "d5c3",
	"./icon-5.png": "0037",
	"./icon-6.png": "11a5",
	"./icon-7.png": "3657",
	"./icon-coin.png": "9648",
	"./icon-family.png": "7eb7",
	"./icon-hospital.png": "b911",
	"./icon-monitor.png": "42a4",
	"./icon-phone.png": "be2a",
	"./icon-speech.png": "2bdf",
	"./icon_arrow.png": "2fc0",
	"./icon_baby.png": "d43c",
	"./icon_family.png": "c8cf",
	"./icon_mom.png": "262f",
	"./icon_monitor.png": "99b9",
	"./introduce.jpeg": "dbbb",
	"./mom-care.png": "9a59",
	"./name-left.png": "fd30",
	"./name-right.png": "7c08",
	"./nurse-feature.png": "a36f",
	"./rectangle.png": "0c38",
	"./voucher.png": "6605d",
	"./weixin.png": "01da",
	"./zhifubao.png": "2faa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8daa";